import apiClient from './apiClient';

class GroupService {
  // Get all groups
  async getAllGroups() {
    try {
      const response = await apiClient.get('/groups?limit=100');
      console.log('GroupService - getAllGroups response:', response.data);
      
      const result = {
        success: true,
        data: response.data?.data || response.data  // Handle both formats
      };
      
      console.log('GroupService - processed result:', result);
      return result;
    } catch (error) {
      console.error('Get all groups error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch groups'
      };
    }
  }

  // Get group by ID
  async getGroupById(groupId) {
    try {
      const response = await apiClient.get(`/groups/${groupId}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get group by ID error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch group'
      };
    }
  }

  // Create new group
  async createGroup(groupData) {
    try {
      const response = await apiClient.post('/groups', groupData);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Create group error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to create group'
      };
    }
  }

  // Update group
  async updateGroup(groupId, groupData) {
    try {
      const response = await apiClient.put(`/groups/${groupId}`, groupData);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Update group error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update group'
      };
    }
  }

  // Delete group
  async deleteGroup(groupId) {
    try {
      const response = await apiClient.delete(`/groups/${groupId}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Delete group error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to delete group'
      };
    }
  }

  // Add user to group
  async addUserToGroup(groupId, userId) {
    try {
      const response = await apiClient.post(`/groups/${groupId}/users`, { userId });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Add user to group error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to add user to group'
      };
    }
  }

  // Remove user from group
  async removeUserFromGroup(groupId, userId) {
    try {
      const response = await apiClient.delete(`/groups/${groupId}/users/${userId}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Remove user from group error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to remove user from group'
      };
    }
  }

  // Get group members
  async getGroupMembers(groupId) {
    try {
      const response = await apiClient.get(`/groups/${groupId}/users`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get group members error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch group members'
      };
    }
  }

  // Update group permissions
  async updateGroupPermissions(groupId, permissions) {
    try {
      const response = await apiClient.patch(`/groups/${groupId}/permissions`, { permissions });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Update group permissions error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update group permissions'
      };
    }
  }

  // Search groups
  async searchGroups(searchTerm) {
    try {
      const response = await apiClient.get(`/groups/search?q=${encodeURIComponent(searchTerm)}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Search groups error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to search groups'
      };
    }
  }

  // Get group statistics
  async getGroupStats() {
    try {
      const response = await apiClient.get('/groups/stats');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get group stats error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch group statistics'
      };
    }
  }

  // Get all available privileges
  async getAllPrivileges() {
    try {
      const response = await apiClient.get('/groups/privileges');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get all privileges error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch privileges'
      };
    }
  }
}

// Create and export a singleton instance
const groupService = new GroupService();
export default groupService;